module.exports = __webpack_public_path__ + "static/hunge-970e26add13dae62fe61d866927f3f12.jpg";